'use strict';

import template from './location_search_prediction.html';

const saLocationSearchPrediction = [
  function () {
    return {
      template: template,
      replace: true,
      scope: {
        prediction: '='
      },
      bindToController: true,
      controllerAs: 'ctrl',
      controller: [
        function () {}
      ]
    };
  }
];

export default saLocationSearchPrediction;



// WEBPACK FOOTER //
// ./app/src/common/location_search/location_search_prediction.js